import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faGift, faShoppingCart, faTicketAlt, faTrophy } from '@fortawesome/free-solid-svg-icons';

const VisiGiftRewards = () => {
  const dummyRewards = [
    {
      id: 1,
      title: '₹50 Grocery Voucher',
      description: 'Redeem for essentials at Mahavir Corner Store or Think5Whys partners.',
      pointsRequired: 500,
      image: '/api/downloads/rewards/grocery-voucher.jpg', // Placeholder
      badge: <FontAwesomeIcon icon={faTicketAlt} className="text-purple-400" />
    },
    {
      id: 2,
      title: '10% Off Electronics',
      description: 'Discount on gadgets and accessories via Think5Whys shopping.',
      pointsRequired: 1000,
      image: '/api/downloads/rewards/electronics-discount.jpg', // Placeholder
      badge: <FontAwesomeIcon icon={faShoppingCart} className="text-purple-400" />
    },
    {
      id: 3,
      title: 'Free Coffee Voucher',
      description: 'One complimentary coffee at local cafes (valid in Mumbai suburbs).',
      pointsRequired: 300,
      image: '/api/downloads/rewards/coffee-voucher.jpg', // Placeholder
      badge: <FontAwesomeIcon icon={faGift} className="text-purple-400" />
    },
    {
      id: 4,
      title: 'Exclusive T-Shirt',
      description: 'Branded VisiGift apparel – limited edition design.',
      pointsRequired: 800,
      image: '/api/downloads/rewards/tshirt.jpg', // Placeholder
      badge: <FontAwesomeIcon icon={faTrophy} className="text-purple-400" />
    },
    {
      id: 5,
      title: '₹100 Book Credit',
      description: 'Credit for digital or physical books on Think5Whys platform.',
      pointsRequired: 1200,
      image: '/api/downloads/rewards/book-credit.jpg', // Placeholder
      badge: <FontAwesomeIcon icon={faStar} className="text-purple-400" />
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-purple-100 font-sans">
      {/* Header */}
      <header className="bg-[#2a0f2f] shadow-sm border-b border-purple-800 px-4 py-3 sticky top-0 z-10">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-xl font-bold text-purple-400">VisiGift Rewards</h1>
          <p className="text-sm text-purple-300 mt-1">Redeem your earned points for amazing perks!</p>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-grow px-4 py-6">
        <section className="text-center mb-6">
          <div className="max-w-md mx-auto">
            <div className="bg-gradient-to-br from-purple-600/20 to-purple-800/20 rounded-lg p-4 mb-4">
              <h2 className="text-lg font-semibold text-purple-300 mb-2">Your Current Points: 1,250</h2>
              <p className="text-sm text-purple-400">Enough for 2 rewards! Keep engaging to earn more.</p>
            </div>
            <p className="text-sm text-purple-300">
              Browse exclusive rewards below. Points expire in 12 months – redeem now!
            </p>
          </div>
        </section>

        {/* Rewards List */}
        <section className="space-y-4">
          {dummyRewards.map((reward) => (
            <div key={reward.id} className="bg-[#2a0f2f] rounded-lg shadow-sm border border-purple-800 overflow-hidden">
              <img
                src={reward.image}
                alt={reward.title}
                className="w-full h-32 object-cover"
              />
              <div className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    {reward.badge}
                    <h3 className="font-semibold text-purple-300">{reward.title}</h3>
                  </div>
                  <span className="bg-purple-600/20 text-purple-300 px-2 py-1 rounded text-xs font-medium">
                    {reward.pointsRequired} pts
                  </span>
                </div>
                <p className="text-sm text-purple-400 mb-4">{reward.description}</p>
                <Link
                  to="/visigift-redeem"
                  className="w-full block bg-purple-600 text-white py-2 px-4 rounded-md text-center font-medium hover:bg-purple-700 transition-colors"
                >
                  Redeem Now
                </Link>
              </div>
            </div>
          ))}
        </section>

        {/* Call to Action */}
        <section className="text-center mt-8">
          <h2 className="text-lg font-semibold mb-2 text-purple-300">Earn More Points</h2>
          <p className="text-sm text-purple-400 mb-4">Watch ads, click buttons, and invite friends to unlock bigger rewards.</p>
          <Link
            to="/visigift-home"
            className="inline-block bg-purple-600 text-white px-6 py-3 rounded-md text-sm hover:bg-purple-700 transition-colors"
          >
            Back to Home
          </Link>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#2a0f2f] border-t border-purple-800 text-purple-300 px-4 py-4 text-center text-sm mt-auto">
        <p>&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved. Powered by VisiGift.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/privacy-policy" className="hover:text-purple-400">Privacy Policy</Link>
          <Link to="/terms-of-use" className="hover:text-purple-400">Terms of Use</Link>
        </div>
      </footer>
    </div>
  );
};

export default VisiGiftRewards;